/* eslint-disable */
import React from 'react';
import {useNavigate} from "react-router-dom"
import 'contents/assets/scss/page/teacher.scss';
function AssignManageWeek() {
  const navigate = useNavigate();
   return (
    <main className="com_container p_assign_manage_weeks">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu2_2 active'>
            배정관리
            <span className='bar'></span>
            <span className="point_txt">홍교사103 (수학)</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className='box full'>
            <div className='com_tab cate'>
                <button onClick={() => navigate("/Mypage/AssignManage")} className='tab'>목록으로 보기</button>
                <button onClick={() => navigate("/Mypage/AssignManageWeeks")} className='tab active'>주간으로 보기</button>
            </div>
            <div className="com_calendar_wrap">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">전체보기</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">출석만 보기</label>
                <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                <label htmlFor="rdo03">수업 예정 보기</label>
              </div>
              <div className="month">
                <section className="com_tab">
                  <button className="tab active">1주</button><button className="tab ">2주</button><button className="tab ">3주</button><button className="tab ">4주</button><button className="tab ">5주</button>
                </section>
              </div>
              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">진행 타임수</span>
                    <span className="operators_value">450</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              달력 영역입니다.
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default AssignManageWeek;
